import { Outlet } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import HomeAppBar from "./components/TopAppBar";
import React from "react";
import LeftNavigationBar from "./components/LeftNavigationBar";
import { Box } from "@mui/material";
import BottomAppBar from "./components/BottomAppBar";

const Layout = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <Box>
      <CssBaseline />
      <HomeAppBar open={open} setOpen={setOpen} />
      <LeftNavigationBar open={open} setOpen={setOpen} />
      <Box sx={{ display: "flex", padding: 8, minWidth: 500 }}>
        <Box component="main" sx={{ flexGrow: 1, p: 3, minHeight: "70vh" }}>
          <Outlet />
        </Box>
      </Box>
      <Box sx={{ marginTop: 30 }}>
        <BottomAppBar />
      </Box>
    </Box>
  );
};

export default Layout;
